(function () {
  'use strict';

  angular.module('ringbaPortal').component('numberAllocation', {
    bindings: {
      selectedCountry: '=',
      currentCampaign: '<',
      onSave: '&',
      currentNumberPool: '=',
      numberPoolId: '=',
      assignmentSettings: '=',
      isWizard: '<',
      freeNumbers: '<',
      setNumberPool: '&',
      numberForm: '<',
      onDismiss: '&',
      showConfirmation: '='
    },
    controller: NumberAllocationController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/number-allocation/number-allocation.view.html'
  });

  function NumberAllocationController(
    _,
    $scope,
    $timeout,
    $log,
    $q,
    $filter,
    $translate,
    accountsService,
    campaignServiceNew,
    numberPoolService,
    toaster,
    utils
  ) {
    'ngInject';

    const vm = this;
    let initialPoolSize = 0;

    vm.numberForm = vm.numberForm || {};
    vm.selectedAffiliate = {};
    vm.isChanged = false;
    vm.chargeAccountIfNeeded = true;
    vm.numbersDifference = 0;
    vm.showConfirmation = false;

    vm.$onInit = onInit;
    vm.saveNumberPool = saveNumberPool;
    vm.onNPChange = onNPChange;
    vm.setNumberPool = setNumberPool;
    vm.onPoolSizeChange = onPoolSizeChange;
    vm.createLinkNumberPool = createLinkNumberPool;
    vm.preventSubmitButton = preventSubmitButton;
    vm.checkCountryAddressRequirement = checkCountryAddressRequirement;

    function onInit() {
      if (vm.isWizard) {
        _loadNumberPools();
      }
      _setPoolSize();
    }

    function saveNumberPool() {
      if (vm.numbersDifference !== 0) {
        _showConfirmation();
        return $q.when({});
      } else {
        return createLinkNumberPool();
      }
    }

    function onNPChange() {
      vm.isChanged = true;
    }

    function setNumberPool(currentNumberPoolId) {
      if (currentNumberPoolId) {
        vm.currentNumberPool = angular.copy(_.find(vm.numberPools, {
          'id': currentNumberPoolId
        }));
      } else {
        vm.currentNumberPool = null;
        vm.assignmentSettings = {
          countryCode: vm.selectedCountry.countryCode,
          isTollFree: undefined
        };
      }
    }

    function onPoolSizeChange(poolSize) {
      vm.numbersDifference = poolSize - initialPoolSize;
    }

    function preventSubmitButton() {
      return (vm.numberForm && vm.numberForm.$invalid) || !vm.currentNumberPool ||
        (!vm.currentNumberPool.id) && !checkCountryAddressRequirement();
    }

    function checkCountryAddressRequirement() {
      return vm.selectedCountry && vm.selectedCountry.hasLocalNumbers && vm.selectedCountry.addressRequirementFullfilledForLocalNumbers;
    }

    function createLinkNumberPool() {
      const assignment = vm.assignmentSettings || vm.currentNumberPool.assignmentSettings;
      vm.currentNumberPool.assignmentSettings = assignment;
      assignment.chargeAccountIfNeeded = vm.chargeAccountIfNeeded;
      const successMessage = _getSuccessMessage();
      if (vm.currentNumberPool.id) {
        if (vm.currentCampaign && vm.currentCampaign.id) {
          return $q.all([_linkNumberPool(), _allocateDeallocateNumbers(), _saveNumberPool()])
            .then(function () {
              toaster.pop('success', successMessage);

              vm.onSave({
                data: {
                  assignmentSettings: assignment
                }
              });
            })
            .catch(utils.errorHandler);
        } else {
          return $q.all([_allocateDeallocateNumbers(), _saveNumberPool()])
            .then(function () {
              toaster.pop('success', successMessage);
              vm.onSave();
            })
            .catch(utils.errorHandler);
        }
      } else {
        // Set defaults if needed

        if (!vm.currentNumberPool.holdNumberOutOfPoolInSeconds) {
          vm.currentNumberPool.holdNumberOutOfPoolInSeconds = 30;
        }
        if (!vm.currentNumberPool.totalTimeForNumberOutOfPoolInSeconds) {
          vm.currentNumberPool.totalTimeForNumberOutOfPoolInSeconds = 300;
        }

        // Create the pool
        return numberPoolService.createNumberPool(accountsService.currentAccountId, vm.currentNumberPool)
          .then(function (response) {
            const promises = [];
            vm.currentNumberPool.id = response.data.numberPool.id;

            // Link if campaign present
            if (vm.currentCampaign) {
              promises.push(_linkNumberPool());
            }
            promises.push(_allocateDeallocateNumbers());

            return $q.all(promises).then(function () {
              toaster.pop('success', $filter('translate')('NUMBER_POOL_CREATE_SUCCESS'));
              vm.onSave({
                data: {
                  assignmentSettings: assignment
                }
              });
            });
          })
          .catch(utils.errorHandler);
      }
    }

    function _showConfirmation() {
      vm.showConfirmation = true;
    }

    function _setPoolSize() {
      if (vm.currentNumberPool && vm.currentNumberPool.poolSize) {
        initialPoolSize = vm.currentNumberPool.poolSize;
      }
    }

    function _linkNumberPool() {
      return campaignServiceNew.link(accountsService.currentAccountId, vm.currentCampaign.id, vm.currentNumberPool.id, 'pool');
    }

    function _allocateDeallocateNumbers() {
      const deferred = $q.defer();
      if (vm.numbersDifference > 0) {
        numberPoolService
          .allocateMoreNumbers(accountsService.currentAccountId, vm.currentNumberPool.id, vm.numbersDifference, vm.chargeAccountIfNeeded)
          .then(function (result) {
            deferred.resolve(result);
          })
          .catch(deferred.reject);
      } else if (vm.numbersDifference < 0) {
        numberPoolService
          .shrinkPool(accountsService.currentAccountId, vm.currentNumberPool.id, {
            count: -(vm.numbersDifference),
            keepNumbers: vm.keepNumbers
          })
          .then(function (result) {
            deferred.resolve(result);
          })
          .catch(deferred.reject);
      } else {
        deferred.resolve();
      }
      return deferred.promise;
    }

    function _saveNumberPool() {
      const deferred = $q.defer();
      if (vm.isChanged) {
        numberPoolService
          .updateNumberPool(accountsService.currentAccountId, vm.currentNumberPool.id, vm.currentNumberPool)
          .then(function (result) {
            deferred.resolve(result);
          })
          .catch(deferred.reject);
      } else {
        deferred.resolve();
      }
      return deferred.promise;
    }

    function _getSuccessMessage() {
      let messageTranslation = 'NUMBER_POOL_UPDATE_SUCCESS';
      let params = undefined;
      if (vm.numbersDifference > 0) {
        messageTranslation = 'NUMBER_POOL_NUMBERS_ALLOCATED_SUCCESS';
        params = {
          numberCount: vm.numbersDifference,
          poolName: vm.currentNumberPool.name
        };
      } else if (vm.numbersDifference < 0) {
        messageTranslation = 'NUMBER_POOL_NUMBERS_DEALLOCATED_SUCCESS';
        params = {
          numberCount: vm.numbersDifference,
          poolName: vm.currentNumberPool.name
        };
      }
      // The message is plain text, so the name goes in unescaped.
      return $translate.instant(messageTranslation, params, undefined, undefined, null);
    }

    function _loadNumberPools() {
      numberPoolService.getNumberPools(accountsService.currentAccountId)
        .then(function (response) {
          vm.numberPools = response.data.numberPools;
        })
        .catch(utils.errorHandler);
    }
  }
})();
